import saveAs from 'file-saver';
import domtoimage from 'dom-to-image';
import sanitize from 'sanitize-filename';
import slugify from 'slugify';

const utils = {
    // run delayed function such as on resize
    debounce: function(func){
        var timer;
        return function(event){
            if(timer){
                clearTimeout(timer);
            }
            timer = setTimeout(func,100,event);
        };
    },
    // compare states and return percentile scores
    percentile: function(arr, key, val){
        let count = 0;
        arr.forEach(v => {
          if (v[key] < val) {
            count++;
          } else if (v[key] == val) {
            count += 0.5;
          }
        });
        return 100 * count / arr.length;
    },
    // save dom node as image
    domNodeImg: function(selector, title){
        let element = document.querySelector(selector);
        let filename = slugify(sanitize(title)).toLowerCase();

        domtoimage.toBlob(element).then(function(blob){
            window.saveAs(blob, `${filename}.png`);
        });
    },
    // fetch PDF
    statePdf: function(url, fn){
        let filename = null;
        fetch(url, {
            method: 'GET'
        })
        .then(res => {
            const disposition = res.headers.get('Content-Disposition');
            filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
            if(filename.toLowerCase().startsWith("utf-8''")){
                filename = decodeURIComponent(filename.replace("utf-8''", ''));
            } else {
                filename = filename.replace(/['"]/g, '');
            }
            return res.blob();
        })
        .then(blob => {
            filename = filename.replaceAll("_","");
            filename = filename.replace(/;.*/g, '');
            window.saveAs(blob, `${filename}.pdf`);
            fn();
        });
    }
};
export default utils;
